export const ORDERS_PENDING_COUNT_REFRESH = "orders-pending-count-refresh";

export const isOrdersRoute = (pathname) =>
  pathname === "/orders" || pathname.startsWith("/orders/");

export const refreshOrdersPendingCount = () => {
  window.dispatchEvent(new CustomEvent(ORDERS_PENDING_COUNT_REFRESH));
};
